import * as React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import {useEffect, useState} from 'react';
import axios from 'axios';
import {
  ChartContainer,
  ChartsReferenceLine,
  ChartsXAxis,
  ChartsYAxis,
  LinePlot,
  ResponsiveChartContainer
} from '@mui/x-charts';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {Unstable_NumberInput as BaseNumberInput} from '@mui/base/Unstable_NumberInput';
import {Card,Button, Box, Typography, Paper,useTheme,CardContent, Grid2} from '@mui/material';
import {styled} from '@mui/system';
import {useGrowSetup} from '../GrowSetupContext';
import { useConfig } from './ConfigContext'
const blue = {
  100: '#daecff',
  200: '#b6daff',
  300: '#66b2ff',
  400: '#3399ff',
  500: '#007fff',
  600: '#0072e5',
  700: '#0059B2',
  800: '#004c99',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const StyledInputRoot = styled('div')(({theme}) => ({
  fontFamily: 'IBM Plex Sans',
  fontWeight: 400,
  color: theme.palette.mode === 'dark' ? grey[300] : grey[500],
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

const StyledInput = styled('input')(({theme}) => ({
  fontSize: '0.875rem',
  fontFamily: 'inherit',
  fontWeight: 400,
  lineHeight: 1.375,
  color: theme.palette.mode === 'dark' ? grey[300] : grey[900],
  background: theme.palette.mode === 'dark' ? grey[900] : '#fff',
  border: `1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]}`,
  borderRadius: 8,
  padding: '10px 12px',
  outline: 0,
  width: '4rem',
  textAlign: 'center',
  '&:hover': {
    borderColor: blue[400],
  },
  '&:focus': {
    borderColor: blue[400],
    boxShadow: `0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]}`,
  },
}));

const StyledButton = styled('button')(({theme}) => ({
  fontFamily: 'IBM Plex Sans',
  fontSize: '0.875rem',
  border: '1px solid',
  borderRadius: '999px',
  background: theme.palette.mode === 'dark' ? grey[900] : grey[50],
  borderColor: theme.palette.mode === 'dark' ? grey[800] : grey[200],
  color: theme.palette.mode === 'dark' ? grey[200] : grey[900],
  width: 32,
  height: 32,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    background: theme.palette.mode === 'dark' ? blue[700] : blue[500],
    borderColor: theme.palette.mode === 'dark' ? blue[500] : blue[400],
    color: grey[50],
    cursor: 'pointer',
  },
  '&.increment': {
    order: 1,
  },
}));

export default function SmallConfigTemperatur(props) {
  const theme = useTheme();
  const {grow_setup, setGrowSetup} = useGrowSetup();
  const { state, dispatch, saveConfig } = useConfig()
  const [dauer, setDauer] = useState(30);
  const [isResponsive, setIsResponsive] = useState(false);
  const Container = isResponsive ? ResponsiveChartContainer : ChartContainer;
  const sizingProps = isResponsive ? {} : {width: 340, height: 300};

  return (
    <Card sx={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, borderRadius: 3, p: 2, boxShadow: 3,display: 'inline-block', width: 'fit-content',mx: 'auto', }}>
    <CardContent sx={{  p: 2 }} >
      <Typography variant="h6" sx={{mb: 2}}>Temperatur</Typography>

      <Grid2 container spacing={2} columns={12}>
        <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
        <ConfigBlock label="Temperatur Tag" description="ab Sonnenaufgang" value={state.config.temperatur_tag}
                     onChange={v => {
                      dispatch({ type: 'SET_FIELD', field: 'temperatur_tag', value: v })

                     }}/>
        </Grid2>
        <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
        <ConfigBlock label="Temperatur Nacht" description="ab Sonnenuntergang" value={state.config.temperatur_nacht}
                     min={15}
                     onChange={v => {
                      dispatch({ type: 'SET_FIELD', field: 'temperatur_nacht', value: v })
                     }}/>
        </Grid2>
        <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
        <ConfigBlock label="Abweichung Tag" description="Toleranz in °C" value={state.config.abweichung_temperatur}
                     step={0.5} max={10}
                     onChange={v => {
                      dispatch({ type: 'SET_FIELD', field: 'abweichung_temperatur', value: v })
                     }}/>
        </Grid2>
        <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
        <ConfigBlock label="Abweichung Nacht" description="Toleranz in °C" value={state.config.abweichung_temperatur}
                     step={0.5} max={10}
                     onChange={v => {
                      dispatch({ type: 'SET_FIELD', field: 'abweichung_temperatur', value: v })
                     }}/>
        </Grid2>
        
      </Grid2>

      <CardContent sx={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Container
          series={[{type: 'line', data: []}]}
          xAxis={[{
            data: [dayjs.startOfYesterday, dayjs.endOfYesterday],
            scaleType: 'band',
            id: 'x-axis-id',
          }]}
          yAxis={[
            {max: 35, min: 0, scaleType: 'linear', id: 'y-axis-id'},
            {max: 100, min: 0, scaleType: 'linear', id: 'y-axis-right-id'},
          ]}
          {...sizingProps}
        >
          <LinePlot/>
          <ChartsXAxis position="bottom" axisId="x-axis-id"/>
          <ChartsYAxis label="Temperatur" position="left" axisId="y-axis-id"/>
          <ChartsReferenceLine y={state.config.temperatur_tag} label="Temperatur Tag" axisId="y-axis-id"
                               lineStyle={{stroke: 'green'}}/>
          <ChartsReferenceLine y={state.config.temperatur_nacht} label="Temperatur Nacht" axisId="y-axis-id"
                               lineStyle={{stroke: 'green'}}/>
        </Container>
      </CardContent>
      {props.is_managed ? <div></div> : 
      <Button fullWidth variant="contained" color="success" sx={{mt: 2}} onClick={saveConfig}>
        Speichern
      </Button>
      }
    </CardContent>
    </Card>
  );
}

function ConfigBlock({label, description, value, onChange, min = 0, max = 30, step = 1}) {
  return (
    <Box display="flex" flexDirection="column" alignItems="start">
      <Typography variant="body1" fontWeight="bold">{label}</Typography>
      <Typography variant="body2" color="text.secondary">{description}</Typography>
      <BaseNumberInput
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e, v) => onChange(v)}
        slots={{
          root: StyledInputRoot,
          input: StyledInput,
          incrementButton: StyledButton,
          decrementButton: StyledButton,
        }}
        slotProps={{
          incrementButton: {children: <AddIcon fontSize="small"/>,className: 'increment',},
          decrementButton: {children: <RemoveIcon fontSize="small"/>},
        }}
      />
    </Box>
  );
}

